var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-empty-function */
import $ from "jquery";
import React from "react";
import { withResizeDetector } from 'react-resize-detector';
import { MappingStorageEventName, nullNcode } from "../common";
import { zIndex_debugTest } from "../common/constants/zIndex";
import { PLAYSTATE, ZoomFitEnum } from "../common/enums";
import { MappingStorage } from "../common/mapper";
import { NeoPdfManager, PdfManagerEventName } from "../common/neopdf";
import { getNPaperSize_pu } from "../common/noteserver";
import { isSamePage, uuidv4 } from "../common/util";
import PageFaultManager from "./PageFaultManager";
import NeoPdfViewDebugInfo from "./pdfview/NeoPdfViewDebugInfo";
import PenBasedRenderer from "./penview/PenBasedRenderer";
export const ZINDEX_INK_LAYER = 3;
export const ZINDEX_PDF_LAYER = 2;
export const ZINDEX_DRAWER = 100;
export const ZINDEX_DRAWER_ICON = 11199;
const pdfContainer = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "100%",
    overflow: "visible",
};
const defaultMixedPageViewProps = {
    id: "mixedview-default",
    // properties
    parentName: "",
    pageInfo: undefined,
    basePageInfo: undefined,
    pens: [],
    playState: PLAYSTATE.live,
    debugInfo: false,
    rotation: 0,
    isMainView: true,
    fitType: ZoomFitEnum.FULL,
    padding: 100,
    width: undefined,
    height: undefined,
    fromStorage: false,
    onPdfRequested: undefined,
    onNcodePageChanged: undefined,
    noMorePdfSignal: false,
    handlePageWidthNeeded: undefined,
    renderCountNo: 0,
    onZoomChanged: undefined,
    setViewFitFn: undefined,
    disableAutoPageChange: false,
    disableMousePen: false,
    disablePanZoom: false,
    disableAutoFocus: false,
    showGrid: false,
    laserPointer: true,
    onPdfPageFault: undefined,
    // 2021/08/04
    pageChangerWriters: undefined,
    onViewPageChanged: undefined,
    onMouseDown: () => { },
    onMouseMove: () => { },
    onMouseUp: () => { },
    onMouseWheel: () => { },
    onTouchTap: () => { },
    onTouchPress: () => { },
};
class MixedPageView_module extends React.Component {
    constructor(props) {
        super(props);
        this.klassName = "MixedPageView";
        this.rendererRef = React.createRef();
        this._loadingTask = undefined;
        this.updateInternalValue = (props) => {
            this._internal.noMorePdfSignal = props.noMorePdfSignal;
            this._internal.widthGiven = props.width !== undefined ? true : false;
            this._internal.heightGiven = props.height !== undefined ? true : false;
            this._internal.pageInfoGiven = props.pageInfo !== undefined ? true : false;
            this._internal.width = props.width !== undefined ? props.width : 0;
            this._internal.height = props.height !== undefined ? props.height : 0;
        };
        // private forceUpdate = () => {
        //   this.setState({ forceToRenderCnt: this.state.forceToRenderCnt + 1 });
        // }
        /**
         * pageInfo를 통해 mapping storage에서 PDF를 찾아 내부의 PDF 관련된 세팅 값을 설정
         * mapping storage에 등록된 PDF가 없으면, props의 handleFileLoadNeeded( {isMapped: false})
         *
         * 등록된 PDF가 있어도 load가 불가능하면, props의 handleFileLoadNeeded( {isMapped: true})
         *
         *
         * @private
         * @param {IPageSOBP} pageInfo
         * @memberof MixedPageView_module
         */
        this.getMappedPdf = (pageInfo) => {
            const msi = MappingStorage.getInstance();
            // const mappedItem = msi.findPdfPage({ ...pageInfo, x: 0, y: 0 });
            const mappedItem = msi.getAssociatedPdfPage(pageInfo);
            return mappedItem;
        };
        this.autoLoadPdf = (mappedItem) => __awaiter(this, void 0, void 0, function* () {
            let pdf = undefined;
            const { url, filename } = mappedItem.pdf;
            try {
                if (this._loadingTask) {
                    this._loadingTask.cancel();
                    this._loadingTask = undefined;
                }
                if (url) {
                    this.setState({ status: "loading" });
                    const loadingTask = NeoPdfManager.getInstance().requsetLoadDocument({
                        url, filename,
                        purpose: "MAIN DOCUMENT: to be opend by NeoPdfViewer"
                    });
                    this._loadingTask = loadingTask;
                    pdf = yield loadingTask.promise;
                    this._loadingTask = undefined;
                    this.setState({ mapperUpdatedCounter: this.state.mapperUpdatedCounter + 1 });
                }
                else {
                    this.setState({ status: "loaded" });
                }
            }
            catch (e) {
                console.log(`rendering cancelled: PDF: ${filename}, ${url}`);
            }
            return pdf;
        });
        this.setPdf = (pdf, pdfPageNo = 1) => {
            const size = pdf.getPageSize(pdfPageNo);
            // this._internal.pdfSize = size;
            // this._internal.pdf = pdf;
            // this._internal.pdfPageNo = pdfPageNo;
            this.setState({ pdf, pdfPageNo, pdfSize: size });
        };
        this.setDummyPdf = (pageInfo = nullNcode()) => {
            const size = getNPaperSize_pu(pageInfo);
            // this._internal.pdfSize = size;
            // this._internal.pdf = undefined;
            // this._internal.pdfPageNo = 0;
            this.setState({ pdf: undefined, pdfSize: size });
        };
        /**
         *
         *
         * @private
         * @param {IPageSOBP} pageInfo
         * @memberof MixedPageView_module
         */
        this.changePage = (pageInfo) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            this.setState({ activePage: Object.assign({}, pageInfo) });
            // undefined 인 경우도 있다. 2021/06/06 kitty
            if (!pageInfo)
                return;
            // 2021/08/04
            if (this.props.onViewPageChanged) {
                if (!isSamePage(this.state.activePage, pageInfo)) {
                    this.props.onViewPageChanged(pageInfo);
                }
            }
            // const msi = MappingStorage.getInstance();
            let mappedItem = this.getMappedPdf(pageInfo);
            if (mappedItem) {
                if (mappedItem.pdf.url) {
                    // PDF URL이 있으면 auto load하도록 한다.
                    yield this.tryToAutoLoadPdf(pageInfo, mappedItem);
                }
                else if ((_b = (_a = mappedItem.pageMapping) === null || _a === void 0 ? void 0 : _a.pdfDesc) === null || _b === void 0 ? void 0 : _b.size_pu) {
                    // 2021/08/25
                    // Overlay인 경우, mapping은 되어 있고, PDF URL은 등록되어 있지 않다.
                    const size = mappedItem.pageMapping.pdfDesc.size_pu;
                    this.setState({ pdf: undefined, pdfSize: Object.assign({}, size) });
                }
                else {
                    this.setDummyPdf(pageInfo);
                }
            }
            else {
                if (this.props.onPdfPageFault) {
                    // 2021/08/18
                    const cnt = PageFaultManager.getInstance().onPageFault(pageInfo);
                    if (cnt <= PageFaultManager.deafultPageFaultMax || this.props.unlimitedPageFault) {
                        yield this.props.onPdfPageFault(pageInfo);
                        mappedItem = this.getMappedPdf(this.state.activePage);
                    }
                }
                // pageInfo에 해당하는 PDF 정보를 찾지 못하면, event를 전달한다
                if (this.props.handlePageWidthNeeded) {
                    this.props.handlePageWidthNeeded({ isMapped: false });
                }
                if (mappedItem) {
                    if (mappedItem.pdf.url) {
                        // PDF URL이 있으면 auto load하도록 한다.
                        yield this.tryToAutoLoadPdf(pageInfo, mappedItem);
                    }
                    else if ((_d = (_c = mappedItem.pageMapping) === null || _c === void 0 ? void 0 : _c.pdfDesc) === null || _d === void 0 ? void 0 : _d.size_pu) {
                        // 2021/08/25
                        // Overlay인 경우, mapping은 되어 있고, PDF URL은 등록되어 있지 않다.
                        const size = mappedItem.pageMapping.pdfDesc.size_pu;
                        this.setState({ pdf: undefined, pdfSize: Object.assign({}, size) });
                    }
                    else {
                        this.setDummyPdf(pageInfo);
                    }
                }
                else {
                    this.setDummyPdf(pageInfo);
                }
                return;
            }
        });
        // 2021/08/12 change page에서 떼어낸 함수
        this.tryToAutoLoadPdf = (pageInfo, mappedItem) => __awaiter(this, void 0, void 0, function* () {
            // let pdf = this._internal.pdf;
            let pdf = this.state.pdf;
            if (!pdf || (pdf.fingerprint !== mappedItem.pdf.fingerprint)) {
                pdf = yield this.autoLoadPdf(mappedItem);
                // if (!pdf) {
                //   this.setDummyPdf(pageInfo);
                // }
                // 2021/08/17 빈페이지 추가에 의해 PDF가 로드되지 않았는데도, setPdf를 하면 안된다.
                // 자연스럽게 빠져나가서 setDummyPdf로 가도록
                if (pdf) {
                    // 2021/08/12 PDF 로딩은 다른 페이지로 바뀐 이후에 들어올 수 있다.
                    if (isSamePage(this.state.activePage, pageInfo)) {
                        this.setPdf(pdf, mappedItem.pageMapping.pdfPageNo);
                    }
                }
            }
            else {
                // 2021/08/12 PDF 로딩은 다른 페이지로 바뀐 이후에 들어올 수 있다.
                this.setPdf(pdf, mappedItem.pageMapping.pdfPageNo);
            }
            // 2021/08/13 그래도 로딩이 안되었으면
            if (!pdf) {
                this.setDummyPdf(pageInfo);
                // PDF를 로드하지 못했으면, event를 전달한다
                if (this.props.onPdfRequested) {
                    const { url, filename } = mappedItem.pdf;
                    this.props.onPdfRequested({
                        url, filename, fingerprint: undefined, pageInfo: undefined, isMapped: true,
                    });
                }
            } // if (pdf)
        });
        /**
         * PDF가 load되었으면 현재 페이지를 update해 줘야 할 수도 있다.
         * @param event
         */
        /*
          onPdfManagerReportLoaded = (event: { pdf: NeoPdfDocument }) => {
            this.setState({ mapperUpdatedCounter: this.state.mapperUpdatedCounter + 1 });
            this.changePage(this.state.activePage)
          }
      
          onMappingStorageReportPdfUpdated = (event: { status: string, docMap: IPdfToNcodeMapItem }) => {
            this.setState({ mapperUpdatedCounter: this.state.mapperUpdatedCounter + 1 });
            this.changePage(this.state.activePage)
          }
          */
        this.lastActivePageOnPdfLoaded = null;
        this.lastFingerprintOnPdfLoaded = null;
        this.onPdfManagerReportLoaded = (event) => {
            const { pdf } = event;
            if (!this.state.activePage)
                return;
            if (!pdf)
                return;
            const { fingerprint } = pdf;
            if (isSamePage(this.lastActivePageOnPdfLoaded, this.state.activePage) &&
                this.lastFingerprintOnPdfLoaded === fingerprint)
                return;
            // 2022/07/19 지금 로드한 PDF가 thumbnail에 해당하는 PDF라고 하면 refresh한다.
            const msi = MappingStorage.getInstance();
            const found = msi.findPdfPage(this.state.activePage);
            // if (!found) return;
            const pg_found = found === null || found === void 0 ? void 0 : found.pdf.pages.filter(pg => isSamePage(pg.pageInfo, this.state.activePage));
            if (!(pg_found === null || pg_found === void 0 ? void 0 : pg_found.length))
                return;
            this.lastFingerprintOnPdfLoaded = pdf.fingerprint;
            this.lastActivePageOnPdfLoaded = this.state.activePage;
            this.changePage(this.state.activePage);
            this.setState({ mapperUpdatedCounter: this.state.mapperUpdatedCounter + 1 });
        };
        this.onMappingStorageReportPdfUpdated = (event) => {
            if (!this.state.activePage)
                return;
            const { docMap } = event;
            if (!docMap) {
                return;
            }
            const { fingerprint } = docMap;
            if (isSamePage(this.lastActivePageOnPdfLoaded, this.state.activePage) &&
                this.lastFingerprintOnPdfLoaded === fingerprint)
                return;
            // 2022/07/19 지금 로드한 PDF가 thumbnail에 해당하는 PDF라고 하면 refresh한다.
            const msi = MappingStorage.getInstance();
            const found = msi.findPdfPage(this.state.activePage);
            // if (!found) return;
            const pg_found = found === null || found === void 0 ? void 0 : found.pdf.pages.filter(pg => isSamePage(pg.pageInfo, this.state.activePage));
            if (!(pg_found === null || pg_found === void 0 ? void 0 : pg_found.length))
                return;
            this.lastFingerprintOnPdfLoaded = fingerprint;
            this.lastActivePageOnPdfLoaded = this.state.activePage;
            this.changePage(this.state.activePage);
            this.setState({ mapperUpdatedCounter: this.state.mapperUpdatedCounter + 1 });
        };
        // loadDocument = async (url: string, filename: string) => {
        //   // const { documentZoom } = this.state;
        //   if (url === undefined) return;
        //   // kitty, 나중에는 분리할 것
        //   // showUIProgressBackdrop();
        //   console.log("*PDF LOADER*, loadDocument START");
        //   const loadingTask = NeoPdfManager.getInstance().getDocument({ url, filename, purpose: "MAIN DOCUMENT: to be opend by NeoPdfViewer" });
        //   this.setState({ status: "loading" });
        //   const pdf = await loadingTask;
        //   if (!pdf) {
        //     if (this.props.onPdfRequested) {
        //       this.props.onPdfRequested({
        //         url,
        //         filename,
        //         fingerprint: undefined,
        //         pageInfo: undefined,
        //         isMapped: true,
        //       });
        //       this.setState({ status: "loaded" });    // kitty
        //     }
        //     return;
        //   }
        //   console.log("*PDF LOADER*, loadDocument COMPLETED")
        //   // let pdfPageNo = this._internal.pdfPageNo;
        //   // let size = pdf.getPageSize(pdfPageNo);
        //   // if (!size) {
        //   //   pdfPageNo = 1;
        //   //   size = pdf.getPageSize(pdfPageNo);
        //   // }
        //   // this._internal.pdf = pdf;
        //   this.setState({ status: "loaded" });
        // }
        this.onViewResized = ({ width, height }) => {
            if (this.props.isOverlayView) {
                this.setState({ pdfSize: { width, height } });
            }
            if (!this._internal.widthGiven) {
                this._internal.width = width;
            }
            if (!this._internal.heightGiven) {
                this._internal.height = height;
            }
        };
        /**
         *
         * @param pageInfo
         * @param isFromEveryPgInfo - 매번 page info가 나올때마다 불려진 것인가? 아니면 페이지가 바뀔때 불려진 것인가?
         */
        this.onNcodePageChanged = (pageInfo, stroke) => {
            // // TODO: 서피스 오너에 반응하지 않아 넣어둔 로그, 찍으면 속도가 느려진다. 확인후에 지우자
            // console.log(`20210720 MixedPageView RendererSurface OnwerIds = `, this.props.surfaceOwnerIds, "   Stroke Owner ID=", stroke.surfaceOwnerId);
            // if (!testOwnerAndWriter(stroke, this.props.surfaceOwnerIds, this.props.writerIds)) return;
            let shouldChangePage = false;
            if (!this.props.disableAutoPageChange) {
                if (this.props.pageChangerWriters) {
                    if (this.props.pageChangerWriters.includes(stroke.writerId)) {
                        shouldChangePage = true;
                    }
                }
                else {
                    shouldChangePage = true;
                }
            }
            if (shouldChangePage) {
                this.setState({ activePage: Object.assign({}, pageInfo) });
                // await this.changePage(pageInfo);
                if (this.props.onNcodePageChanged) {
                    this.props.onNcodePageChanged(pageInfo, stroke);
                }
            }
        };
        this.handlePageWidthNeeded = (width) => {
            // 2021/04/19 kitty, 이것 나중에 살펴 볼 것
            // props에 스위치를 달아야 하지 않나?
            if (this.props.parentName === "grida-main-home")
                this.props.handlePageWidthNeeded(width);
        };
        this.onCanvasPositionChanged = (arg) => {
            const shouldReportZoom = this._internal.viewPos.zoom !== arg.zoom;
            this._internal.viewPos = Object.assign({}, arg);
            // 2015/08/25
            this.setRendererDivPosition(arg);
            this.setState({ forceToRenderCnt: this.state.forceToRenderCnt + 1 });
            if (shouldReportZoom && this.props.isMainView && this.props.onZoomChanged) {
                this.props.onZoomChanged(arg.zoom);
            }
            this.handlePageWidthNeeded(this._internal.width);
        };
        this.setRendererDivPosition = (position) => {
            const style = {};
            if (this._internal.viewControlledBy === "mouse") {
                style.transitionDuration = "0.1s";
                style.WebkitTransitionDuration = "0.1s";
            }
            if (this.props.disableScrollBar) {
                // 2021/08/09
                // disableScrollBar가 있으면, 이전 스타일로 아래의 객체들을 -offset도 가질 수 있도록 한다
                style.left = position.offsetX / 1;
                style.top = position.offsetY / 1;
            }
            else {
                // 2021/08/09
                // scroll bar를 쓴다면, 스크롤바를 통해 view position을 움직이도록 한다.
                style.left = position.offsetX > 0 ? position.offsetX : 0;
                style.top = position.offsetY > 0 ? position.offsetY : 0;
                // const domEl = document.getElementById(this._absDivId);
                const el = $("#" + this._absDivId);
                if (el) {
                    const scrollLeft = position.offsetX > 0 ? 0 : -position.offsetX;
                    const scrollTop = position.offsetY > 0 ? 0 : -position.offsetY;
                    // el.scrollTop(scrollTop);
                    // el.scrollLeft(scrollLeft);
                    el.stop().animate({ scrollTop, scrollLeft, }, { duration: 100, easing: "linear" });
                }
            }
            const inkLayerDiv = $(`#${this._absDivId}-ink_layer`);
            inkLayerDiv.attr("left", style.left);
            inkLayerDiv.attr("top", style.top);
            inkLayerDiv.attr("transitionDuration", style.transitionDuration);
            inkLayerDiv.attr("WebkitTransitionDuration", style.WebkitTransitionDuration);
            return style;
        };
        this.handleMouseWheel = (event) => {
            // const rndr = this._rendererObj.renderer;
            // const opt = { e: event };
            // rndr.onCanvasMouseWheel(opt, true);
            // event.preventDefault();
            // event.stopPropagation();
            return false;
        };
        this.onChildObjectReport = (obj) => {
            this._rendererObj = obj;
        };
        /** 2021/08/25, mouse이면 애니메이션 있는 부드러운 스크롤, touch이면 애니메이션 없는 바로 스크롤 */
        this.onViewPositionControlledBy = (device) => {
            this._internal.viewControlledBy = device;
        };
        this._uuid = uuidv4();
        this.state = {
            forceToRenderCnt: 0,
            status: "N/A",
            activePage: nullNcode(),
            pdf: undefined,
            pdfPageNo: undefined,
            pdfSize: { width: 0, height: 0 },
            mapperUpdatedCounter: 0,
        };
        this._internal = {
            viewPos: { offsetX: 0, offsetY: 0, zoom: 1 },
            widthGiven: false,
            heightGiven: false,
            width: 0,
            height: 0,
            pageInfoGiven: false,
            noMorePdfSignal: false,
            viewControlledBy: "mouse",
            // pdf: null,
            // pdfPageNo: 1,
            // pdfSize: { width: 0, height: 0 }
            initialSize: { width: 0, height: 0 },
        };
        this.updateInternalValue(props);
        this.setDummyPdf();
        const uuid = uuidv4();
        this._absDivId = `${this.props.parentName}-mixed_view-absolute-${uuid}`;
    }
    componentDidMount() {
        // PDF가 refresh 되면, 현재 page의 배경을 update해 줘야 할수도 있다. 2021/06/06 kitty
        const dm = NeoPdfManager.getInstance();
        dm.addEventListener(PdfManagerEventName.ON_PDF_LOADED, this.onPdfManagerReportLoaded);
        const msi = MappingStorage.getInstance();
        msi.addEventListener(MappingStorageEventName.ON_PDF_UPDATED, this.onMappingStorageReportPdfUpdated);
        msi.addEventListener(MappingStorageEventName.ON_MAPINFO_REFRESHED, this.onMappingStorageReportPdfUpdated);
        msi.addEventListener(MappingStorageEventName.ON_MAPINFO_ADDED, this.onMappingStorageReportPdfUpdated);
        this.changePage(this.props.pageInfo);
    }
    shouldComponentUpdate(np, ns) {
        // console.log(`pageChange: MixedPageView: ${Math.round(np.forceDeltaTime)}sec  ${makeNPageIdStr(np.pageInfo)}`);
        const p = this.props;
        const s = this.state;
        // const mm = this._internal;
        this.updateInternalValue(np);
        let ret = false;
        if (!isSamePage(p.pageInfo, np.pageInfo) && !isSamePage(ns.activePage, np.pageInfo)) {
            this.setState({ activePage: Object.assign({}, np.pageInfo) });
        }
        if (!isSamePage(s.activePage, ns.activePage)) {
            this.changePage(ns.activePage);
            ret = true;
        }
        if (p.replayStorage !== np.replayStorage) {
            console.log(np.replayStorage);
            ret = true;
        }
        if (np.width !== p.width || np.height !== p.height) {
            this.onViewResized({ width: np.width, height: np.height });
            ret = true;
        }
        ret = ret || (p.hidden !== np.hidden);
        ret = ret || (s.pdfSize !== ns.pdfSize);
        ret = ret || (s.pdf !== ns.pdf);
        ret = ret || (s.pdfPageNo !== ns.pdfPageNo);
        ret = ret || (np.pens !== p.pens);
        ret = ret || (np.fitType !== p.fitType);
        ret = ret || (np.disablePanZoom !== p.disablePanZoom);
        ret = ret || (np.debugInfo !== p.debugInfo);
        ret = ret || (s.forceToRenderCnt !== ns.forceToRenderCnt);
        ret = ret || (p.disableMousePen !== np.disableMousePen);
        ret = ret || (p.disableAutoPageChange !== np.disableAutoPageChange);
        ret = ret || (p.isCropMode !== np.isCropMode);
        ret = ret || (p.cropRect !== np.cropRect);
        ret = ret || (p.showGrid !== np.showGrid);
        ret = ret || (p.disableAutoFocus !== np.disableAutoFocus);
        ret = ret || (p.renderCountNo !== np.renderCountNo);
        ret = ret || (p.enablePlateInput !== np.enablePlateInput);
        ret = ret || (p.laserPointer !== np.laserPointer);
        ret = ret || (p.replayStorage !== np.replayStorage);
        ret = ret || (p.playState !== np.playState);
        ret = ret || (p.replaySpeed !== np.replaySpeed);
        ret = ret || (p.forceDeltaTime !== np.forceDeltaTime);
        // 2021/06/13
        ret = ret || (np.writerIds !== p.writerIds);
        ret = ret || (np.surfaceOwnerIds !== p.surfaceOwnerIds);
        ret = ret || (np.storage !== p.storage);
        ret = ret || (np.onViewPageChanged !== p.onViewPageChanged);
        // 2021/08/04
        ret = ret || (np.zoom !== p.zoom);
        // 2021/08/17
        ret = ret || (s.status !== ns.status);
        ret = ret || (s.mapperUpdatedCounter !== ns.mapperUpdatedCounter);
        // 2021/08/25
        ret = ret || (p.onMouseDown !== np.onMouseDown);
        ret = ret || (p.onMouseMove !== np.onMouseMove);
        ret = ret || (p.onMouseUp !== np.onMouseUp);
        ret = ret || (p.onMouseWheel !== np.onMouseWheel);
        ret = ret || (p.onTouchTap !== np.onTouchTap);
        ret = ret || (p.onTouchPress !== np.onTouchPress);
        ret = ret || (p.isOverlayView !== np.isOverlayView);
        return ret;
    }
    componentWillUnmount() {
        var _a;
        // PDF가 refresh 되면, 현재 page의 배경을 update해 줘야 할수도 있다. 2021/06/06 kitty
        const dm = NeoPdfManager.getInstance();
        dm.removeEventListener(PdfManagerEventName.ON_PDF_LOADED, this.onPdfManagerReportLoaded);
        const msi = MappingStorage.getInstance();
        msi.removeEventListener(MappingStorageEventName.ON_PDF_UPDATED, this.onMappingStorageReportPdfUpdated);
        msi.removeEventListener(MappingStorageEventName.ON_MAPINFO_REFRESHED, this.onMappingStorageReportPdfUpdated);
        msi.removeEventListener(MappingStorageEventName.ON_MAPINFO_ADDED, this.onMappingStorageReportPdfUpdated);
        (_a = this._loadingTask) === null || _a === void 0 ? void 0 : _a.cancel();
    }
    render() {
        const zoom = this._internal.viewPos.zoom;
        const pdfCanvas = {
            position: "absolute",
            zoom: zoom,
            left: this._internal.viewPos.offsetX / zoom,
            top: this._internal.viewPos.offsetY / zoom,
            background: "#fff",
        };
        const position = this._internal.viewPos;
        const inkInternalDivBase = {
            position: "absolute",
            zoom: 1,
            // 2021/08/09 생략
            // left: position.offsetX / 1,
            // top: position.offsetY / 1,
            // 2021/08/04 kitty
            // width: "100%",
            // height: "100%",
            overflow: "visible",
            // transitionDuration: "0.1s",
            // WebkitTransitionDuration: "0.1s",
        };
        const addtionalStyle = this.setRendererDivPosition(position);
        const inkInternalDiv = Object.assign(Object.assign({}, inkInternalDivBase), addtionalStyle);
        // // 2021/08/25
        // if (this._internal.viewControlledBy === "mouse") {
        //   inkInternalDiv.transitionDuration = "0.1s";
        //   inkInternalDiv.WebkitTransitionDuration = "0.1s";
        // }
        // if (this.props.disableScrollBar) {
        //   // 2021/08/09
        //   // disableScrollBar가 있으면, 이전 스타일로 아래의 객체들을 -offset도 가질 수 있도록 한다
        //   inkInternalDiv.left = position.offsetX / 1;
        //   inkInternalDiv.top = position.offsetY / 1;
        // }
        // else {
        //   // 2021/08/09
        //   // scroll bar를 쓴다면, 스크롤바를 통해 view position을 움직이도록 한다.
        //   inkInternalDiv.left = position.offsetX > 0 ? position.offsetX : 0;
        //   inkInternalDiv.top = position.offsetY > 0 ? position.offsetY : 0;
        //   // const domEl = document.getElementById(this._absDivId);
        //   const el = $("#" + this._absDivId);
        //   if (el) {
        //     const scrollLeft = position.offsetX > 0 ? 0 : -position.offsetX;
        //     const scrollTop = position.offsetY > 0 ? 0 : -position.offsetY;
        //     // el.scrollTop(scrollTop);
        //     // el.scrollLeft(scrollLeft);
        //     el.stop().animate({ scrollTop, scrollLeft, }, { duration: 100, easing: "linear" });
        //   }
        // }
        // console.log(`zoom = ${zoom}`);
        const _a = this.props, { pageInfo } = _a, rest = __rest(_a, ["pageInfo"]);
        const pageCanvas = {
            position: "absolute",
            zoom: 1,
            left: 0,
            top: 0,
            width: 600,
            zIndex: zIndex_debugTest,
            // background: "#fff"
        };
        return (_jsx("div", Object.assign({ id: `${this.props.parentName}-mix-rel-${this._uuid}`, style: {
                position: "relative",
                margin: 0,
                padding: 0,
                width: "100%",
                height: "100%",
                // 2021/08/04 kitty, scroll bar 표시
                // 2021/08/09 생략
                // overflow: this.props.disableScrollBar ? "hidden" : "auto",
                // overflow: "hidden",
            } }, { children: _jsxs("div", Object.assign({ id: this._absDivId, onWheelCapture: this.handleMouseWheel, 
                // onClick ={(e) => { console.log("onClick ") }}
                // onMouseMove ={(e) => { console.log("onMouseMove ") }}
                // onMouseOver ={(e) => { console.log("onMouseOver ") }}
                // onMouseEnter={(e) => { console.log("onMouseEnter") }}
                style: {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    right: 0,
                    height: "100%",
                    alignItems: "center",
                    // zIndex: 1,
                    zoom: 1,
                    // 2021/08/09 kitty, scroll bar 표시
                    // overflow: this.props.disableScrollBar ? "hidden" : "auto",
                    overflow: this.props.disableScrollBar ? "hidden" : "auto",
                    // overflow: "auto",
                } }, { children: [this.props.debugInfo ?
                        _jsx("div", Object.assign({ id: `${this._absDivId}-pdf_layer`, style: pdfContainer }, { children: _jsx("div", Object.assign({ id: `${this._absDivId}-pdf_view`, style: pdfCanvas }, { children: _jsx(NeoPdfViewDebugInfo, { pageInfo: this.state.activePage, basePageInfo: this.state.activePage, pdfPageNo: this.state.pdfPageNo, 
                                    // pdfPageNo={this._internal.pdfPageNo}
                                    pageCanvas: pageCanvas, pdf: this.state.pdf, fontSize: this.props.fontSize ? this.props.fontSize : 14 }) })) }))
                        : "", _jsx("div", Object.assign({ id: `${this._absDivId}-ink_layer`, style: inkInternalDiv }, { children: _jsx(PenBasedRenderer, Object.assign({}, rest, { hidden: this.props.hidden, pdf: this.state.pdf, pdfPageNo: this.state.pdfPageNo, pdfSize: this.state.pdfSize, 
                            // pdf={this._internal.pdf}
                            // pdfPageNo={this._internal.pdfPageNo}
                            // pdfSize={this._internal.pdfSize}
                            onCanvasPositionChanged: this.onCanvasPositionChanged, position: this._internal.viewPos, viewSize: {
                                width: this._internal.width,
                                height: this._internal.height
                            }, pageInfo: this.state.activePage, onNcodePageChanged: this.onNcodePageChanged, handleChildReport: this.onChildObjectReport, mapperUpdatedCounter: this.state.mapperUpdatedCounter, onViewPositionControlledBy: this.onViewPositionControlledBy })) }))] })) })));
    }
}
MixedPageView_module.defaultProps = defaultMixedPageViewProps;
const AdaptiveWithDetector = withResizeDetector(MixedPageView_module);
const MixedPageView = (props) => {
    return (_jsx(React.Fragment, { children: _jsx(AdaptiveWithDetector, Object.assign({}, props)) }));
};
export default MixedPageView;
//# sourceMappingURL=MixedPageView.js.map